t = require('views/internal/teacup-with-helpers')('dialog_close_button')

module.exports = ->
  t.a '.icon-lg.icon-close.dialog-close-button.js-close-window', { href: '#' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/dialog_close_button.coffee